/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Dropdown, Image, Table, TableColumnsType } from "antd";
import { useRef, useState } from "react";
import { SubServiceType } from "../../../ducks/types";
import { MoreOutlined } from "@ant-design/icons";
import EmptyCard from "../../../../../atoms/EmptyCard";

interface PropsType {
  materialData: SubServiceType | null;
  onClose: () => void;
}

export default function MaterialModal(props: PropsType) {
  const { materialData } = props;
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const [tableRecord, setTableRecord] = useState<SubServiceType | null>(null);
  const dropdownRef = useRef<HTMLButtonElement>(null);

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/edit-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
          }}
        >
          Edit
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={
            <Image
              src={`/images/table/${
                tableRecord?.status === "active" ? "archive" : "activate"
              }-icon.svg`}
              preview={false}
            />
          }
          onClick={(e) => {
            e.stopPropagation();

            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          {tableRecord?.status === "active" ? "Archive" : "Activate"}
        </Button>
      ),
    },
    {
      key: "3",
      label: (
        <Button
          type="text"
          className="delete-hover"
          icon={<Image src="/images/table/delete-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          Delete
        </Button>
      ),
    },
  ];

  const columns: TableColumnsType<SubServiceType> = [
    {
      title: "Material",
      dataIndex: "name",
      width: 439,
      fixed: "left",
      sorter: (a, b) =>
        (a?.name ?? "").toString().localeCompare((b?.name ?? "").toString()),
      render: (text) => text ?? "-",
    },
    {
      title: "Use rate",
      dataIndex: "use_rate",
      width: 150,
      align: "right",
    },
    {
      title: "Total need",
      dataIndex: "total_need",
      width: 150,
      align: "right",
    },
    {
      title: "Unit cost",
      dataIndex: "unit_cost",
      width: 142,
      align: "right",
    },
    {
      title: "Unit price",
      dataIndex: "unit_price",
      width: 142,
      align: "right",
    },
    {
      title: "Total cost",
      dataIndex: "total_cost",
      width: 127,
      align: "right",
    },
    {
      title: "Total price",
      dataIndex: "total_price",
      width: 127,
      align: "right",
    },
    {
      title: "Material GM",
      dataIndex: "gross_margin_perc",
      width: 130,
      align: "right",
      render: (text) => text ?? "-",
    },
    {
      title: <Image src="/images/table/menu-burger.svg" preview={false} />,
      dataIndex: "action",
      width: 52,
      fixed: "right",
      render: (_text, record) => (
        <Dropdown
          menu={{
            items,
          }}
          trigger={["click"]}
          placement="bottomRight"
          className="actionButton"
        >
          <Button
            onClick={(e) => {
              setTableRecord(record);
              e.stopPropagation();
            }}
            onKeyDown={(e) => e.stopPropagation()}
            style={{
              padding: "6px",
              height: "auto",
              background: "transparent",
            }}
            className="only_icon"
            icon={<MoreOutlined />}
            ref={dropdownRef}
          />
        </Dropdown>
      ),
    },
  ];

  // const deleteFunction = () => {
  //   setLoading(true);

  // };

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    type: "checkbox" as const,
  };

  return (
    <>
      <h2 style={{ marginBottom: 4 }}>{materialData?.name}</h2>
      <p style={{ marginBottom: 16 }}>
        Proposal: Maintenance Standard - Warm Season
      </p>

      {/* <Alert
        message={
          <>
            This service uses a broad material category in its template. For
            accurate pricing, choose specific material below.
            <br />
            <br />
            Otherwise, you can leave it as is and select the material during
            ordering - the price shown here will be an average price of all the
            materials in that category.
          </>
        }
        type="warning"
        style={{ background: "#E7EAFF", marginBottom: 16, width: "800px" }}
        showIcon
        icon={<Image src="/images/estimate/alert-icon.svg" preview={false} />}
      /> */}

      {materialData?.material?.length === 0 ? (
        <div className="empty_wrap">
          <EmptyCard
            imageHeight={70}
            title="There are no materials"
            description=""
            image="/images/empty-icons/no-archived.svg"
          />
        </div>
      ) : (
        <Table
          rowSelection={rowSelection}
          columns={columns}
          dataSource={materialData?.material}
          scroll={{ x: "max-content" }}
          pagination={false}
          rowKey="index"
          summary={() => (
            <Table.Summary fixed="bottom">
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={6}>
                  Total
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1} align="right">
                  $4,592
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2} align="right">
                  $4,592
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3} align="right">
                  $4,592
                </Table.Summary.Cell>
                <Table.Summary.Cell index={4} />
              </Table.Summary.Row>
            </Table.Summary>
          )}
          sticky={{ offsetHeader: 64 }}
        />
      )}
    </>
  );
}
